/**
 * Potencia item
 * @param {*} editor
 */
function power(editor) {
  const cm = editor.codemirror;
  const selectedText = cm.getSelection();
  const text = selectedText;

  const output = `^{${text}}`;
  cm.replaceSelection(output);
}

export default function () {
  const option = {
    name: 'Potencia',
    action: power,
    className: 'powericon',
    title: 'Potencia',
  };

  return option;
}
